// extracted by mini-css-extract-plugin
module.exports = {"desktopSearchMenu":"qR-z","selections":"rR-z","pillsDesktopSearchMenu":"sR-z"};